import React from 'react';
import { pr } from '../../../ui-components/common';

export default function BookDemoBtn(props) {
  return (
    <a
      href='https://calendly.com/welcome-to-submittal-com/book-a-demo'
      target="_blank"
      //onClick={pr}
      className={`__btn ${props.className || ''}`}>
      Book a demo
    </a>
  );
}